import 'react-toastify/dist/ReactToastify.css'
import './global.css'

import { ChakraProvider } from '@chakra-ui/react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { AppRoutes } from '@/app.routes'
import { ErrorBoundary } from '@/components/common/error-boundary'
import ScrollToAnchor from '@/components/common/ScrollToAnchor'
import { Toaster } from '@/components/ui/sonner'
import { UserAbilityProvider } from '@/features/sessao/providers/auth-context'
import { queryClient } from '@/lib/queryClient'
import { ChakraTheme } from '@/styles/theme.ts'

import { TooltipProvider } from './components'

function RoutesWithErrorBoundary() {
  const { pathname } = useLocation()

  // The boundary stays mounted across navigation (see resetKey comment in
  // error-boundary.tsx) and clears itself once the user moves to a new page.
  return (
    <ErrorBoundary resetKey={pathname}>
      <AppRoutes />
    </ErrorBoundary>
  )
}

function Component() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={ChakraTheme}>
          <TooltipProvider>
            <UserAbilityProvider>
              <RoutesWithErrorBoundary />
              <ScrollToAnchor />
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
              <Toaster />
            </UserAbilityProvider>
          </TooltipProvider>
        </ChakraProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

export default Component
